import menuToggle from './menu';
import lazyLoad from './lazyLoad';
import archivClear from './archivSrcClear';

require('./bootstrap');
menuToggle();
// lazyLoad();
archivClear();
